const filesAlloud = ['PDF', 'JPG', 'PNG'];
const allowedExtensions = /(.jpg|.jpeg|.png|.pdf)$/i;
const checkFileType = (file) => {
  let flag = false;

  if (allowedExtensions.exec(file.name)) {
    flag = true;
  }
  return flag;
};

const isFileAlreadyAdded = (fileIncoming, filesAdded) =>
  !!filesAdded.find((file) => file.name === fileIncoming.name);

export default function validFile(file, filesAdded) {
  if (isFileAlreadyAdded(file, filesAdded)) {
    return { succes: false, err: 'El archivo ya fue agregado' };
  }
  if (file.size < 10000000) {
    if (checkFileType(file, filesAlloud)) {
      return { succes: true, err: null };
    }
    return { succes: false, err: 'El formato del archivo no es compatible' };
  }
  return { succes: false, err: 'El tamaño del archivo supera los 10 MB.' };
}
